export const SOMETHING_WENT_WRONG = "Something went wrong with request";
export const NO_AVAILABLE_MODEL = "No available model";
